import { render, staticRenderFns } from "./FavoriteFormulaCard.vue?vue&type=template&id=e8fb4d5c&scoped=true&"
import script from "./FavoriteFormulaCard.vue?vue&type=script&lang=js&"
export * from "./FavoriteFormulaCard.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteFormulaCard.vue?vue&type=style&index=0&id=e8fb4d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fb4d5c",
  null
  
)

export default component.exports